import axios from "axios";
import { BACKEND_URL, REQUEST_TIMEOUT_MS } from "../constants/environment";

const api = axios.create({
  timeout: REQUEST_TIMEOUT_MS,
  baseURL: BACKEND_URL
});

export default api;
